import { Button } from '@/ui/design-system/components/ui/button';
import Link from 'components/Link';
import { cn } from '@/ui/design-system/utils/cn';
import { forwardRef } from 'react';
import { withMixpanelClick } from 'utils/app';

const INTENT_TO_VARIANT = {
    primary: 'default',
    secondary: 'outline',
};

const TrackedLinkButtonInner = forwardRef(function TrackedLinkButtonInner(
    {
        IconLeft,
        IconRight,
        children,
        isDisabled,
        intent = 'primary',
        wrapText = false,
        variant,
        size,
        mixpanelContext,
        className,
        to,
        smooth,
        ...props
    },
    ref,
) {
    return (
        <Button
            ref={ref}
            variant={variant || INTENT_TO_VARIANT[intent] || 'default'}
            size={size || 'default'}
            disabled={!!isDisabled}
            asChild
            className={cn(
                'no-underline',
                wrapText && 'whitespace-normal',
                className,
            )}
            {...props}
        >
            <Link to={to} smooth={smooth}>
                {IconLeft && (
                    <span className="size-4 shrink-0 flex items-center">
                        <IconLeft className="!size-[1.2em] shrink-0 opacity-50" />
                    </span>
                )}
                {children}
                {IconRight && (
                    <span className="size-4 shrink-0 flex items-center">
                        <IconRight className="!size-[1.2em] shrink-0 opacity-50" />
                    </span>
                )}
            </Link>
        </Button>
    );
});

const TrackedLinkButton = withMixpanelClick(
    TrackedLinkButtonInner,
    'LinkButton',
);

export default TrackedLinkButton;
